export const BUTTON = {
  default: {
    boxShadow: '0px `8px 15px rgba(0, 0, 0, 0.1)',
    border: '0px'
  }
}
